import { TImpression } from '../../types/types'

export const getProductImpressions = (
	impressions: TImpression[] = [],
	category: string
): Record<string, any> | null => {
	if (!impressions.length) return null

	return {
		ecommerce: {
			currencyCode: 'RUB',
			impressions: impressions.map(({ product, location, position }) => {
				return {
					id: product.KOD,
					name: product.TITLE,
					price: product.PRICE.VALUE,
					brand: product.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values[0],
					category: category,
					list: location,
					position
				}
			})
		}
	}
}
